import { FooterView } from '@shared/components/FooterView/FooterView';
import { useCookie } from '@shared/contexts/cookie-context';
import { useCurrencies } from '@shared/contexts/currencies-context';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

type FooterLink = {
  id: 'terms' | 'privacy' | 'eula' | 'cookie'
  link: string
}

const FOOTER_LINKS: FooterLink[] = [
  {
    id: 'terms',
    link: 'https://fableborne.com/terms',
  },
  {
    id: 'privacy',
    link: 'https://fableborne.com/privacy',
  },
  {
    id: 'eula',
    link: 'https://fableborne.com/eula',
  },
];

export const Footer: FC = () => {
  const { t } = useTranslation();
  const { setShowBanner } = useCookie();

  const getCookie = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setShowBanner(true);
  };

  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const links = useMemo(
    () => FOOTER_LINKS.map((link) => ({
      ...link,
      label: t(`legal.${link.id}`),
    })),
    [t],
  );

  const { selectedCountryInfo, openRegionChangeModal } = useCurrencies();

  return (
    <FooterView
      links={links}
      footerTranslations={{ joinTheCommunity: t('footer.joinTheCommunity') }}
      currentYear={currentYear}
      discordUrl="https://discord.com/invite/fableborne"
      twitterUrl="https://x.com/fableborne"
      getCookie={getCookie}
      currencyChangeCountryInfo={selectedCountryInfo}
      onCurrencyChangeClick={openRegionChangeModal}
    />
  );
};
